import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FileUploader } from "react-drag-drop-files";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import ClosedIcon from "@mui/icons-material/Close";
import { callAPI } from "../../../axios";
import BasicModal from "../../core/BaseComponents/Modal";
import { getChainIdLS } from "../../../utils/utils";
import ImageResolutionTooltip from "./ImageResolutionTooltip";

export default function UploadImage(props) {

  const data = [
    {
      name: "Hotel Logo",
      files: 1,
      size: "700 KB",
      height: "option1: 48, option2: 45, option3: 48",
      width: "option1: 240, option2: 90, option3: 48",
      resolution: "72 PPI",
      aspect: "option1 - 1:5, option2 - 1:2, option3 - 1:1",
      formats: "JPG, JPEG, PNG",
    }
  ];

  const [showUploadImagePopUp, setShowUploadImagePopUp] = useState(false);
  const [rowUploadData, setRowUploadData] = useState([]);
  const [url, setUrl] = useState("");
  const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
  const [imageFile, setImageFile] = useState();

  const uploadAppLogoHandler = (rowList) => {
    setShowUploadImagePopUp(true);
    setRowUploadData(rowList);
  };

  const closePopupHandler = () => {
    setShowUploadImagePopUp(false);
    setUrl("");
    setFileSizeErrorMsg("");
  };

  const handleFileDragChange = (file) => {
    const bytes = file.size;
    setImageFile(file);
    const burl = URL.createObjectURL(file);
    setUrl(burl);
  };

  const uploadImageHandler = (uploadId) => {
    if (fileSizeErrorMsg !== "") {
      return;
    }
    const formData = new FormData();
   
    formData.append("logo", imageFile);

    callAPI(`/hotel-logo?active=true`, "POST", formData, { chainId:uploadId?.chainID })
      .then((response) => {
        props?.hotelListApi();
        setShowUploadImagePopUp(false);
        setUrl("");
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  return (
    <>
      {!props?.disabled?<Tooltip title="Upload Logo" arrow>
        <LogoutIcon
          className={`upload-icon ${props?.row?.logoUrl === null ? "cursor-pointer" : "btn-disable-rail"
            } rotate-270`}
          onClick={() => uploadAppLogoHandler(props?.row)}
        />
      </Tooltip>:<Tooltip title="Don't have permission to upload logo" arrow>
        <span>
      <LogoutIcon
        className={`upload-icon btn-disable-rail rotate-270`}
        // onClick={() => uploadAppLogoHandler(props?.row)}
      />
      </span>
    </Tooltip>}
      {showUploadImagePopUp && (
        <BasicModal
          popupOpen={showUploadImagePopUp}
          bodyMessage={
            <div className="file-uploader-hotel-config">
              <p className="">{fileSizeErrorMsg}</p>
              <FileUploader
                name="file"
                handleChange={handleFileDragChange}
                classes="file-uploader"
                types={["JPG", "PNG", 'JPEG']}
                children={
                  <div>
                    <p>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                    </p>
                    <p className="drag-drop-content">
                      Drag and drop or
                      <span> Click here</span>
                    </p>
                    <p className="upload-content">To upload your image
                    <ImageResolutionTooltip data={data} position={"bottom"}/>
                    </p>
                  </div>
                }
              />
              {url && (
                <div className="upload-preview">
                  <p className="preview-content">Preview</p>
                  <div className="preview-image">
                    <ClosedIcon
                      fontSize={"2px"}
                      className="cursor-pointer close-icon image-preview"
                      onClick={() => {
                        setUrl("");
                        setFileSizeErrorMsg("");
                      }}
                    />
                    <img
                      src={url}
                      alt="Preview-image"
                    />
                  </div>
                </div>
              )}
            </div>
          }
          customcss={true}
          footer={
            {
              primaryButton: {
                buttonName: "Cancel",
                action: closePopupHandler,
                buttonPrimaryCustomCss: 'cancel-btn_new'
              }
              ,
              secondaryButton: {
                buttonName: "Upload",
                action: () => uploadImageHandler(rowUploadData)
              }
            }
          }
        />
      )}
    </>
  );
}
